import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentInterface } from '../data';
import { DocumentProvider } from '../providers/document.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetDocumentContentUseCaseParams {
    document: DocumentInterface;
}

@Injectable()
export class GetDocumentContentUseCase implements UseCaseWithParam<GetDocumentContentUseCaseParams, Observable<Transaction<any>>> {
    constructor(private documentProvider: DocumentProvider) {}

    bind(params: GetDocumentContentUseCaseParams): Observable<Transaction<any>> {
        return this.documentProvider.detail(params.document);
    }
}
